import * as LoadingMarkers from "./LoadingMarkers";    

import "../css/Button.css";

const Button = ({btnStyle, children, loading, ...props}) => {
    return <button
        className="button"
        {...props}
    >
        {!loading && children || <i className='fa-solid fa-spinner loading-icon'/>}
    </button>
}

export default Button;